import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject, Subscription, throwError, EMPTY } from "rxjs";
import { IConfig } from './shared/config';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from "../environments/environment";
import { AlertService } from "./shared/alert.service";
import { User, Role } from './shared/models/user-model';
import { IProfileLinks, IProduct } from './shared/models/profilelink.model';
import { catchError, map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  user: User;

  private globalConfigSrcFile = 'assets/jsons/config.json';
  private appConfigLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private appConfig: IConfig;

  title = new Subject<string>();
  display = new Subject<string>();
  minyear: number = (new Date()).getFullYear();
  vendorID: number = 0;
  vendorname = new Subject<string>();
  isAdmin: boolean = false;
  isReadonlyAdmin: boolean = false;
  // isCustomer:boolean;
  admin = new Subject<string>();
  disableMenuChanged = new Subject<boolean>();
  private subscription: Subscription;
  disableMenu: boolean = false;
  listselectedyear: number = 0;
  listselectedquarter: number = 0;
  isProductEligible = new Subject<boolean>();
  // searchvalue = new Subject<string>();
  // private searchvalue: BehaviorSubject<string> = new BehaviorSubject("");
  private searchvalue: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private searchyear: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  hover_megamenu;
  public  isonetFeature:Observable<any>;

  setTitle(title: string) {
    if (title == 'DashBoard') {
      this.display.next('none');
      this.admin.next('none');
    } else { this.display.next('block') }
    this.title.next(title);
  }
  constructor(private http: HttpClient, private alertService: AlertService, private cookieService: CookieService) {
    this.user = new User();
    this.http.get<IConfig>(this.globalConfigSrcFile).subscribe(
      config => {
        this.appConfig = config;
        this.appConfigLoaded.next(true);
      }
    );
    this.subscription = this.disableMenuChanged
      .subscribe(
        (disableMenu) => {
          this.disableMenu = disableMenu;
        }
      );

    //TODO: remove this and prf auth wheen prf auth is ready
    this.isonetFeature = this.http.get(`${environment.isonetFeatureFlagApi}`).pipe(map(x => x['featureFlag']))
  }


  getConfigStatus(): Observable<boolean> {
    return this.appConfigLoaded.asObservable();
  }
  getGlobalConfig(): IConfig {
    return this.appConfig;
  }


    setUserIdAndType(Cookiecstid: string):boolean {
      localStorage.setItem('prfcstid', Cookiecstid);
      let  hasAdminRole = false;
      if (+Cookiecstid == environment.MasterId) {
        this.isAdmin = true;
        this.user.role = Role.Admin;
        hasAdminRole = true;
      }
      else if (+Cookiecstid == parseInt(environment.ViewerId)) {
        this.isReadonlyAdmin = true;
        this.user.role = Role.Admin;
        hasAdminRole = true;
      } else {
        this.user.role = Role.Customer;
      }
      return hasAdminRole
  }


  validateVendor() {
    if (this.disableMenu) {
      this.alertService.clear();
      if (this.isAdmin) {
        this.alertService.error("Please choose a Vendor from the list");
      }
      else {
        this.alertService.error("Invalid Vendor");
      }
      return false;
    }
    return true;

  }

  hasRole(role: Role) {
    return this.user.role === role;
  }

  getAllUserProfileLinks(): Observable<IProfileLinks[]> {
    // let url
    return this.http.get<IProfileLinks[]>(environment.PRODUCTS_URL + `/API/ViewLinks/GetAll`).pipe(
      // tap(data => console.log('Header API Data: ' + JSON.stringify(data))),
      catchError(this.handleError)
    );
  }
  getUserProducts(userId: string, token: string): Observable<IProduct[]> {
    if (!token) {
      return EMPTY;
    }
    const appId = this.cookieService.get('prd_ctx') ? this.cookieService.get('prd_ctx') : window.location.hostname;
    const headers = new HttpHeaders().set('App-Id', appId)

      .set('Authorization', "Bearer " + token);
    return this.http.get<IProduct[]>(environment.PRODUCTS_URL + `/api/Panels/v3/GetUserProductsWithTicket?userId=${userId}`, { headers }).pipe(
      // tap(data => console.log('UserProducts API Data: ' + JSON.stringify(data))),
      catchError(this.handleError)
    );
  }

  getAllProducts() {
    return this.http.get(environment.PRODUCTS_URL + `/api/Panels/GetPublishedProducts`).pipe(
      // tap(data => console.log('AllProducts API Data: ' + JSON.stringify(data))),
      catchError(this.handleError)
    );
  }
  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    return throwError(() => new Error(errorMessage));
  }

  getUserEligibleproduct(apiUrl: string, productid: string, token: string): Observable<string> {
    return this.http.get(`${apiUrl}/isUserEligibleForProduct/${token}/${productid}`, { responseType: 'text' }).pipe(

      catchError(this.handleError)
    );
  }
  getUserEligibleproductv2(productIdAlias: string, token: string): Observable<boolean> {
    if (!token) {
      return EMPTY
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get(`${environment.EligibilityUrl}/user/profile/customer/detail/user/product/${productIdAlias}/v2`, { responseType: 'text', headers: headers }).pipe(
      map(x => {
        return x.length > 0
      }),
      catchError(this.handleError)
    );
  }


  logout() {
    localStorage.removeItem('prfcstid');
    localStorage.setItem('groupcode', '');
    localStorage.setItem('groupname', '');
    localStorage.setItem('year', '');
    localStorage.removeItem('isLocked');
    localStorage.setItem("searchValue", "");
    localStorage.setItem("searchType", "");
    localStorage.setItem('currentyearadmin', '');
    localStorage.setItem('currentyearcust', '');
    localStorage.removeItem('prfStatus');
    localStorage.removeItem('prfstatusfilter');
    console.log("APP COMP LOGOUT")
    // this.entitlementService.setLoginStatus(false);
    // this.oauthService.logOut();
    sessionStorage.clear();
    var id_token = sessionStorage.getItem('id_token');
    var logoutUrl =
      environment.GATEWAY_LOGOUT +
      environment.IDENTITY_LOGOUT +
      '?id_token_hint=' +
      id_token +
      '&post_logout_redirect_uri=' +
      window.location.origin;
    window.location.href = logoutUrl;
  }
}


